import React from 'react'
import { redirect, RouteObject } from 'react-router-dom'

import UsersPage from 'pages/UsersPage'
import CreateUserPage from 'pages/CreateUserPage'
import UpdateUserPage from 'pages/UpdateUserPage'
import LabelsPage from 'pages/LabelsPage'
import LabelCreatePage from 'pages/LabelCreatePage'
import LabelEditPage from 'pages/LabelEditPage'
import MessagesPage from 'pages/MessagesPage'
import ArtistPage from 'pages/ArtistsPage'
import ArtistEditPage from 'pages/ArtistsEditPage'
import ProductChartMatchesPage from 'pages/ProductChartMatchesPage'
import ChartSourcesPage from 'pages/ChartSourcesPage'

import { AdminLayout } from './Layout'
import { CanRoute } from 'shared/abilities'

export const adminRoute: RouteObject = {
  element: <AdminLayout />,
  children: [
    {
      index: true,
      loader: () => redirect('/admin/users')
    },
    {
      path: 'users',
      children: [
        { index: true, element: <UsersPage /> },
        {
          path: 'new',
          element: <CreateUserPage />
        },
        {
          path: ':id',
          element: <UpdateUserPage />
        }
      ]
    },
    {
      path: 'labels',
      children: [
        {
          index: true,
          element: <LabelsPage />
        },
        {
          path: 'new',
          element: <CanRoute I="create" a={'Zone'} />,
          children: [
            {
              index: true,
              element: <LabelCreatePage />
            }
          ]
        },
        {
          path: ':id',
          element: <LabelEditPage />
        }
      ]
    },
    {
      path: 'messages',
      element: <MessagesPage />
    },
    {
      path: 'artists',
      element: <ArtistPage />
    },
    {
      path: 'product-chart-match',
      element: <ProductChartMatchesPage />
    },
    {
      path: 'artists/:id',
      element: <ArtistEditPage />
    },
    {
      path: 'chart-sources',
      element: <ChartSourcesPage />
    },
  ]
}
